import { defaultReducer } from 'app/store/defaultReducer';
import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import { ContratoTypes } from './ContratoAction';

export const ContratosInitState = createStateTool({
  registro: undefined,
  visualizar: false,
  cadastrar: false,
  buscaAvancada: false,
  rescisaoContrato: false,
  visualizarPendencias: false,
  pendencias: [],
  page: {
    content: [],
  },
  requestParams: {
    page: 0,
    size: 15,
    q: undefined,
    sort: 'cliente.pessoa.nome,ASC',
    totalCount: undefined,
  },
  selection: [],
  message: undefined,
  search: undefined,
  selecionados: [],
  carregandoRegistro: false,
  carregandoRegistros: false,
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
  filtroAvancado: {
    identificador: undefined,
    situacao: 'ATIVO',
    cliente: undefined,
    servico: undefined,
    categoria: undefined,
  },
  somatorioFiltro: undefined,
});

function reducer(state, action, types) {
  if (action.type === ContratoTypes.SET_FILTRO_AVANCADO) {
    return {
      ...state,
      filtroAvancado: action.payload,
    };
  }

  if (action.type === ContratoTypes.OPEN_RESCISAO_CONTRATO) {
    return {
      ...state,
      rescisaoContrato: true,
      registro: action.payload,
    };
  }

  if (action.type === ContratoTypes.CLOSE_RESCISAO_CONTRATO) {
    return {
      ...state,
      rescisaoContrato: false,
      registro: undefined,
    };
  }

  if (action.type === ContratoTypes.BUSCAR_SOMATORIO_FILTRO) {
    return {
      ...state,
      somatorioFiltro: action.payload,
    };
  }

  if (action.type === ContratoTypes.VISUALIZAR_MODAL_PENDENCIAS) {
    return {
      ...state,
      visualizarPendencias: action.payload,
    };
  }

  if (action.type === ContratoTypes.SET_PENDENCIAS) {
    return {
      ...state,
      pendencias: action.payload,
    };
  }

  if (action.type === ContratoTypes.CLEAR_FILTRO) {
    return {
      ...state,
      filtroAvancado: ContratosInitState.filtroAvancado,
      requestParams: ContratosInitState.requestParams,
      search: '',
    };
  }

  return defaultReducer(state, action, types);
}

export const ContratoReducer = createReducerTool(reducer, ContratoTypes);
